// react-i18next bootstrap. Wired in MFA-enrollment L1b per
// mfa-enrollment-spec.md §8 + decisions-log.md 2026-05-15 (i18n from day one).
//
// Phase 1: es-MX is the maintained catalog; `en` is partial — platform-staff
// strings only — per architecture/frontend-architecture.md §13.4. Catalogs are
// authored against design/copy-and-microcopy.md and filled in feature by
// feature; L6 (/account/security) is the first page authored with keyed
// strings. Scaffold pages (Login / MFA / Home) are NOT re-keyed here — the
// Phase G design re-skin replaces them.
//
// Resources are imported statically: the Phase 1 catalog is a handful of small
// JSON files, so per-namespace lazy-loading is deferred until the catalog is
// large enough to be worth it.

// Import via the '@vysto/shared/i18n' subpath, NOT the package barrel: the
// barrel transitively pulls in jsonwebtoken / pino (Node-only) and crashes the
// browser bundle. The subpath resolves to the pure locale module only.
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@vysto/shared/i18n'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enAdmin from './locales/en/admin.json'
import enCommon from './locales/en/common.json'
import enComponents from './locales/en/components.json'
import enErrors from './locales/en/errors.json'
import enInbox from './locales/en/inbox.json'
import esMXAdmin from './locales/es-MX/admin.json'
import esMXCommon from './locales/es-MX/common.json'
import esMXComponents from './locales/es-MX/components.json'
import esMXErrors from './locales/es-MX/errors.json'
import esMXInbox from './locales/es-MX/inbox.json'

// `components` holds the @vysto/web design-system's own built-in microcopy
// (button labels, aria-labels, empty-state defaults). Design-system components
// call `useTranslation('components')` so they translate themselves; pages still
// pass their own content via props. es-MX is the maintained catalog.
/** i18next namespaces — one per broad UI surface. */
export const I18N_NAMESPACES = ['common', 'inbox', 'admin', 'errors', 'components'] as const

const resources = {
  'es-MX': {
    common: esMXCommon,
    inbox: esMXInbox,
    admin: esMXAdmin,
    errors: esMXErrors,
    components: esMXComponents,
  },
  en: {
    common: enCommon,
    inbox: enInbox,
    admin: enAdmin,
    errors: enErrors,
    components: enComponents,
  },
}

void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: SUPPORTED_LOCALES,
  ns: I18N_NAMESPACES,
  defaultNS: 'common',
  interpolation: {
    // React escapes interpolated values already.
    escapeValue: false,
  },
  returnNull: false,
})

export default i18n
